import { makeStyles, NavDrawer, NavDrawerBody, NavItem, tokens } from "@fluentui/react-components";
import { Board20Filled, Board20Regular, Box20Filled, Box20Regular, BoxMultiple20Filled, BoxMultiple20Regular, bundleIcon, BuildingShop20Filled, BuildingShop20Regular, Cart20Filled, Cart20Regular, Settings20Filled, Settings20Regular, PeopleMoney20Filled, PeopleMoney20Regular } from "@fluentui/react-icons";
import { Outlet } from "react-router";

const useStyles = makeStyles({
    main: {
        display: "flex",
        alignItems: "flex-start",
        gap: "1rem",
        height: "calc( 100vh - 55px )",
    }
});

const DashboardIcon = bundleIcon( Board20Filled, Board20Regular );
const SalesIcon = bundleIcon( Cart20Filled, Cart20Regular );
const CustomersIcon = bundleIcon( PeopleMoney20Filled, PeopleMoney20Regular );
const ProductsIcon = bundleIcon( BoxMultiple20Filled, BoxMultiple20Regular );
const VendorsIcon = bundleIcon( BuildingShop20Filled, BuildingShop20Regular );
const DropboxesIcon = bundleIcon( Box20Filled, Box20Regular );
const SettingsIcon = bundleIcon( Settings20Filled, Settings20Regular );

export default function InnerTemplate()
{
    const styles = useStyles();

    let pageId = window.location.pathname.substring( 1 ).trim().toLowerCase();
    if( pageId == "" )
        pageId = "dashboard";

    //
    // Strip any trailing slashes from the pageId
    //
    if( pageId.includes( "/" ) )
        pageId = pageId.substring( 0, pageId.indexOf( "/" ) );

    return <>
        <div>
            <main className={styles.main}>
                <NavDrawer surfaceMotion={null} open={true} type="inline" selectedValue={pageId} style={{ flex: "0 0 auto", height: "100%" }}>
                    <NavDrawerBody>
                        <NavItem href="/dashboard" value="dashboard" icon={<DashboardIcon />}>Dashboard</NavItem>
                        <NavItem href="/sales" value="sales" icon={<SalesIcon />}>Sales</NavItem>
                        <NavItem href="/customers" value="customers" icon={<CustomersIcon />}>Customers</NavItem>
                        <NavItem href="/products" value="products" icon={<ProductsIcon />}>Products</NavItem>
                        <NavItem href="/vendors" value="vendors" icon={<VendorsIcon />}>Vendors</NavItem>
                        <NavItem href="/dropboxes" value="dropboxes" icon={<DropboxesIcon />}>Dropboxes</NavItem>
                        <NavItem href="/settings" value="settings" icon={<SettingsIcon />}>Settings</NavItem>
                    </NavDrawerBody>
                </NavDrawer>
                <Outlet />
            </main>
        </div>
    </>;
}